import styled, { css } from "styled-components";
// import { colors } from "../../utils";
import { colors, hoverHighlight, focusRingColor } from "../../utils";
import { TextView } from "@components";
import { CHAT_ICON_FOLD_MAX_PX, mq } from "../../utils/breakpoints";

export const Container = styled.div`
  height: 8vh;
  width: 100%;
  background-color: ${colors.background};
  display: grid;
  grid-template-columns: 40% 20% 40%;
  box-shadow: 0px 4px 7px 0px #00000014;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CenterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Logo = styled.img`
  height: 6vh;
  width: 6vh;
  margin-left: 3vw;
  margin-right: 3vw;
  cursor: pointer;
`;

export const SearchBar = styled.div`
  text-align: left;
`;

export const CreateWheelContainer = styled.div`
  position: absolute;
  top: 0;
  border: 10px solid ${colors.background};
  background-color: ${colors.background};
  border-radius: 50%;
  height: 10vh;
  width: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0px 13px 8px -5px #00000014;
  cursor: pointer;
`;

export const InviteContainer = styled.div`
  text-align: center;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: 14px;
  cursor: pointer;
  width: 140px;
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin-right: 1vw;
`;

export const FeedbackIcon = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 5px;
`;
// gordon-1002-P2 — named so WheelHeader's builder-only equal-gap cluster can
// cancel this exact value on a wrapper (negative margin) instead of
// hardcoding a magic 10 that would silently drift if this changed.
export const USER_CONTAINER_MARGIN_LEFT_PX = 10;
// T22.429 — the avatar ring's box and the trailing margin after it, named so
// WheelHeader can centre the builder avatar on the right icon rail from the
// real numbers (see WheelHeader/avatarRailAlign.js).
export const PROFILE_AVATAR_SIZE_PX = 46;
export const PROFILE_AVATAR_MARGIN_RIGHT_PX = 10;

export const UserContainer = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 5px;
  padding-bottom: 5px;
  margin-left: ${USER_CONTAINER_MARGIN_LEFT_PX}px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  /* A7 (a11y): the avatar is a keyboard-operable menu trigger (role="button").
     Give it a visible focus ring for keyboard users (WCAG 2.4.7); :focus-visible
     only so a pointer click never paints the ring. */
  &:focus-visible {
    outline: 2px solid ${focusRingColor};
    outline-offset: 2px;
  }
`;

export const CreateWheelImage = styled.img`
  background-color: ${colors.background};
  width: 100%;
  height: 100%;
`;

export const LoggingOut = styled(TextView)`
  display: inline-block;
  clip-path: inset(0 4ch 0 0);
  animation: l 1s steps(4) infinite;
  font-weight: 700;
`;

export const ButtonView = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
`;

export const Button = styled.div`
  width: 90px;
  height: 4vh;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: ${colors.lightBlue};
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  background-color: ${colors.white};
  min-width: 160px;
  top: 7vh;
  box-shadow: 0px 4px 7px 0px #00000014;
  border-radius: 5px;
  padding: 5px;
  /* review-1008-Frontend-7837 (T22.714 follow-up): anchor to the avatar's
     right edge at EVERY width. The old constant left:-140px put the 254px
     menu's right edge 58px right of the avatar box, i.e. 38px past the
     viewport, wherever the avatar sits at the header's right end — measured
     live on web-stg main.8121706f at 900/1024/1194 touch and 1200/1280/1440
     desktop (menu right = viewport + 38, selected-account checkmark cut). */
  left: auto;
  right: 0;
  z-index: 999999999999999999999999;
  ${(props) =>
    props.clicked &&
    `
      background-color: ${colors.lightBlue};
    `}

  &:hover {
    cursor: pointer;
  }

  /* freeze-reverify-acct-switcher-mobile-popover-overflow: the constant
     left:-140px anchor above is tuned for desktop's wide gap to the avatar's
     left. At phone widths the avatar sits close enough to the viewport edge
     that -140px still isn't far enough left for the dropdown's real content
     width, so its right edge spills past the viewport (measured 46px past
     390px live). Anchoring to the container's own right edge instead means
     it can never extend further right than the avatar itself, which is
     already on-screen. */
  ${mq.phone} {
    left: auto;
    right: 0;
  }
`;

export const PHONE_DROPDOWN_ITEM_HEIGHT_PX = 48;
// T22.714: tablet-portrait touch row (measured 34px at 768); 44px minimum.
export const TABLET_DROPDOWN_ITEM_HEIGHT_PX = 44;

// Register bug #909: hardcoded 10px/4px duplicated (and slightly drifted from)
// the app's ONE hoverHighlight spec. Same padding/radius, sourced from the
// shared token so this row stays in lockstep with every other hover-highlighted
// row/dropdown-item instead of drifting again later.
export const DropdownItem = styled.div`
  text-align: left;
  height: 34px;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: ${hoverHighlight.paddingY}px ${hoverHighlight.paddingX}px;
  color: black;
  border-radius: ${hoverHighlight.radius}px;
  background-color: ${(props) =>
    props.isActive ? colors.PrimaryPurple100 : "transparent"};
  &:hover {
    background-color: ${colors.PrimaryPurple100};
  }

  /* T22.207 (phone UX audit UX-07): the 34px/14px desktop row is a cramped
     touch target on a phone (measured 34px rows on web-stg at 390x844).
     Phone band gets a 48px row and 16px label (Material/HIG touch target);
     desktop keeps the original 34px row; tablet portrait (T22.714) gets a
     44px touch row at the desktop label size. */
  ${mq.tabletPOnly} {
    height: ${TABLET_DROPDOWN_ITEM_HEIGHT_PX}px;
  }
  ${mq.phone} {
    height: ${PHONE_DROPDOWN_ITEM_HEIGHT_PX}px;
    font-size: 16px;
    /* row labels are <TextView> <p>s that set their own 14px */
    & > p {
      font-size: 16px;
    }
  }
`;

export const DropdownImage = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 10px;
`;

export const DropdownImage2 = styled.img`
  width: 17px;
  height: 17px;
  margin-right: 8.5px;
  margin-left: -2px;
`;

export const DropdownImage3 = styled.img`
  width: 19px;
  height: 19px;
  margin-right: 7px;
  margin-left: -2px;
`;

export const WrapperMainDiv = styled.div`
  width: 30vw;
  height: 92vh;
  overflow-y: auto;
  background-color: white;
  // z-index: 1000;
  border-radius: 4px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  padding: 24px 16px 0px 16px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(1px);
    `}
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.lightBorder};
`;

// T22.615: GalleryHeader's folded nav rows (Discover/Capture/Messages/Share
// Gallery) live in the avatar dropdown ONLY below the tabletP cut (<=899px) —
// the same cut where the header icons for those pages are display:none — so
// desktop/tablet-landscape menus are unchanged. The rows are MUI MenuItems
// (NavEntryMenuItem); match this dropdown's own row height and label size.
export const FoldedNav = styled.div`
  display: none;
  ${mq.tabletP} {
    display: block;
    /* UserContainer is text-align:right (avatar trigger); the rows must not
       inherit it, and they use the same padding / gray 18px icon / radius
       as this dropdown's own DropdownItem rows so the merged menu reads as
       one list. */
    text-align: left;
    & .MuiMenuItem-root {
      min-height: ${TABLET_DROPDOWN_ITEM_HEIGHT_PX}px !important;
      height: ${TABLET_DROPDOWN_ITEM_HEIGHT_PX}px;
      padding: ${hoverHighlight.paddingY}px ${hoverHighlight.paddingX}px;
      border-radius: ${hoverHighlight.radius}px;
      gap: 0;
    }
    & .MuiMenuItem-root:hover {
      background-color: ${colors.PrimaryPurple100};
    }
    & .MuiListItemIcon-root {
      min-width: 0 !important;
      margin-right: 8px;
      margin-left: -2px;
    }
    & .MuiListItemIcon-root svg {
      width: 18px !important;
      height: 18px !important;
      font-size: 18px !important;
      color: #667085 !important;
    }
    & .MuiListItemText-root {
      margin: 0;
    }
    /* measured 12px for this dropdown's TextView rows at 768 (tabletP).
       The label is the bare ListItemText root (no Typography child), so
       size the row, the root and the primary span alike. */
    & .MuiMenuItem-root,
    & .MuiListItemText-root,
    & .MuiListItemText-primary {
      color: black;
      font-size: 12px !important;
    }
  }
  ${mq.phone} {
    & .MuiMenuItem-root {
      min-height: ${PHONE_DROPDOWN_ITEM_HEIGHT_PX}px !important;
      height: ${PHONE_DROPDOWN_ITEM_HEIGHT_PX}px;
    }
    & .MuiMenuItem-root,
    & .MuiListItemText-root,
    & .MuiListItemText-primary {
      font-size: 16px !important;
    }
  }
`;

// Wrapper for the avatar's Messages unread badge. T22.715: only where the
// header's own Messages icon (and its badge) is folded away — at or below
// CHAT_ICON_FOLD_MAX_PX; wider phones and tablets show the badge on Messages.
export const FoldedOnly = styled.span`
  display: none;
  @media (max-width: ${CHAT_ICON_FOLD_MAX_PX}px) {
    display: contents;
  }
`;
